import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export const useSearcherPresenter = ({
  list,
  name,
  onChange: onChangeProp,
  onClick: onClickProp,
  onSearch: onSearchProp,
  value: valueProp,
}) => {
  const inputRef = useRef();
  const dropDownRef = useRef();

  const selected = useMemo(() => {
    return list.find((option) => {
      const { id } = option ?? {};

      return id === valueProp;
    });
  }, [list, valueProp]);

  const { title } = selected ?? {};

  const [value, setValue] = useState(title);
  const [visible, setVisible] = useState(false);
  const [isFocused, setItsFocused] = useState(false);

  const onHide = useCallback(() => {
    setVisible(false);
  }, []);
  const onOptionClick = useCallback(
    (item) => {
      onChangeProp(name ? { [name]: item } : item);
      onHide();
    },
    [onChangeProp, name, onHide]
  );
  const onOutsideClick = useCallback(
    (event) => {
      const { target } = event ?? {};

      if (!target || !dropDownRef.current || dropDownRef.current.contains(event.target)) {
        return;
      }

      setValue(title);
      onHide();
    },
    [title, onHide]
  );
  const onClick = useCallback(
    (...args) => {
      setVisible((state) => {
        return !state;
      });
      onClickProp(...args);
    },
    [onClickProp]
  );
  const onSearch = useCallback(
    (event) => {
      const { target } = event ?? {};

      if (!target) {
        return;
      }

      const { value: search } = target;

      setValue(search);
      onSearchProp(name ? { [name]: search } : search, { event });
    },
    [onSearchProp, name]
  );

  const onFocus = useCallback(() => {
    setItsFocused(true);
  }, []);

  const onBlur = useCallback(() => {
    setItsFocused(false);
  }, []);

  useEffect(() => {
    if (!isFocused) {
      setValue(title);
    }
  }, [title]);

  useEffect(() => {
    window.addEventListener('scroll', onHide);
    window.addEventListener('resize', onHide);

    return () => {
      window.removeEventListener('scroll', onHide);
      window.removeEventListener('resize', onHide);
    };
  }, [onHide]);

  return {
    dropDownRef,
    inputRef,
    onClick,
    onOptionClick,
    onOutsideClick,
    onSearch,
    onFocus,
    onBlur,
    value,
    visible,
  };
};
